// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_tvY","cls2":"PaperClaiming-cls2_qQr PaperClaiming-cls1_tvY"};